import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../context/LanguageContext";
import Navigation from "../../Navigation";
import Footer from "../../Footer";

const ZkSnarkPage = () => {
  const { language } = useLanguage();

  // 翻译
  const translations = {
    backToProjects: {
      en: "Back to Projects",
      zh: "返回项目列表",
      ja: "プロジェクトに戻る",
    },
    title: {
      en: "zk-SNARK - Delivery Feasibility Proof System",
      zh: "zk-SNARK - 物流可行性证明系统",
      ja: "zk-SNARK - 配送実現可能性証明システム",
    },
    underConstruction: {
      en: "Sorry, this page is under construction, but it will become a flagship project",
      zh: "不好意思，还在做，但是会成为代表项目的",
      ja: "申し訳ありませんが、まだ作成中です。代表的なプロジェクトになる予定です",
    },
    tagline: {
      en: "Privacy-preserving solution for delivery feasibility verification",
      zh: "保护隐私的物流可行性验证解决方案",
      ja: "プライバシーを保護する配送実現可能性検証ソリューション",
    },
  };

  // 技术栈数据
  const techStack = [
    { name: "Circom 2.0", category: "zkp" },
    { name: "snarkjs", category: "zkp" },
    { name: "Solidity", category: "blockchain" },
    { name: "Hardhat", category: "blockchain" },
    { name: "Next.js", category: "frontend" },
    { name: "React", category: "frontend" },
  ];

  // 按类别获取技术标签的颜色
  const getTagColor = (category) => {
    switch (category) {
      case "zkp":
        return "bg-purple-100 text-purple-800";
      case "blockchain":
        return "bg-blue-100 text-blue-800";
      case "frontend":
        return "bg-cyan-100 text-cyan-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-neutral-50">
      <Navigation activeSection="projects" />
      <div className="pt-24 pb-12 px-6">
        <div className="container mx-auto max-w-5xl">
          <div className="mb-6">
            <Link
              to="/projects"
              className="text-primary-500 hover:text-primary-600 transition-colors flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
              {translations.backToProjects[language] ||
                translations.backToProjects.en}
            </Link>
          </div>

          <header className="mb-12 text-center">
            <h1 className="text-4xl md:text-5xl font-light mb-4 text-neutral-800">
              {translations.title[language] || translations.title.en}
            </h1>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              {translations.tagline[language] || translations.tagline.en}
            </p>

            {/* 技术栈标签 */}
            <div className="mt-6 flex flex-wrap justify-center gap-2">
              {techStack.map((tech, index) => (
                <span
                  key={index}
                  className={`${getTagColor(
                    tech.category
                  )} px-3 py-1 rounded-full text-sm font-medium`}
                >
                  {tech.name}
                </span>
              ))}
            </div>
          </header>

          {/* 施工中内容 */}
          <section className="mb-16 flex flex-col items-center justify-center">
            <div className="max-w-xl mx-auto text-center mb-8">
              <p className="text-2xl font-light text-neutral-800 mb-4">
                {translations.underConstruction[language] ||
                  translations.underConstruction.en}
              </p>
            </div>

            <div className="w-full max-w-2xl mx-auto">
              <img
                src="/assets/projects/zksnark/sorry.png"
                alt="Coming Soon Placeholder"
                className="w-full h-auto rounded-xl shadow-md my-6"
              />
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ZkSnarkPage;
